import { ADDRESS_FIELDS, formatAddressFromGoogleApi } from '@btime/helpers'
import { geocodeByPlaceId } from 'react-places-autocomplete'
import { head, is, pick } from 'ramda'

export const getAddressFromGoogleApi = async placeId => {
  const result = head(await geocodeByPlaceId(placeId))
  return formatAddressFromGoogleApi(result)
}

export const formatAddressForApi = address => {
  if (!address) return address
  if (is(String, address)) address = { search: address }
  return pick(ADDRESS_FIELDS, address)
}
